// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"886991f9","787":"43b67c2d"}[chunkId] + ".chunk.js";
};